import { render } from "./ArticleTpl.vue?vue&type=template&id=4b5f0a44"
import script from "./ArticleTpl.vue?vue&type=script&lang=js"
export * from "./ArticleTpl.vue?vue&type=script&lang=js"

import "./ArticleTpl.vue?vue&type=style&index=0&id=4b5f0a44&lang=css"

import exportComponent from "/Users/medvedevpavel/Documents/code/lb_advice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__